import React from 'react';
import { BasicProperties } from './BasicProperties';
import { DefaultValueProperty } from './DefaultValueProperty';
import { DefaultSelectionProperty } from './DefaultSelectionProperty';
import { SwitchDefaultProperty } from './SwitchDefaultProperty';
import { ColumnWidthProperty } from './ColumnWidthProperty';
import { RequiredProperty } from './RequiredProperty';
import { ValidationsProperty } from './ValidationsProperty';
import { ConditionsProperty } from './ConditionsProperty';
import { OptionsProperty } from './OptionsProperty';
import { HeadingTagProperty } from './HeadingTagProperty';
import { ParagraphTypeProperty } from './ParagraphTypeProperty';
import { MultiselectProperty } from './MultiselectProperty';
import { RepeaterFieldsProperty } from './RepeaterFieldsProperty';
import { ContainerFieldsProperty } from './ContainerFieldsProperty';
import { CurrencyProperty } from './CurrencyProperty';
import { PriceProperty } from './PriceProperty';
import { PhoneProperty } from './PhoneProperty';
import { HiddenFieldProperty } from './HiddenFieldProperty';

/**
 * Main Properties Panel component
 */
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const PropertiesPanel = _ref => {
  let {
    selectedFieldData,
    selectedField,
    fields,
    updateField,
    updateValidation,
    updateCondition,
    removeCondition,
    addCondition,
    accordionStates,
    toggleAccordion,
    updateOption,
    removeOption,
    addOption,
    updateRepeaterField,
    removeRepeaterField,
    addRepeaterField,
    collapsed = false,
    onToggleCollapse
  } = _ref;
  if (collapsed) {
    return /*#__PURE__*/_jsx("div", {
      className: "builder-properties builder-properties-collapsed",
      children: /*#__PURE__*/_jsx("div", {
        className: "properties-header",
        children: /*#__PURE__*/_jsx("button", {
          type: "button",
          onClick: onToggleCollapse,
          className: "properties-toggle-btn",
          title: "Expand Properties",
          children: "\u25B6"
        })
      })
    });
  }
  if (!selectedFieldData) {
    return /*#__PURE__*/_jsxs("div", {
      className: "builder-properties",
      children: [/*#__PURE__*/_jsxs("div", {
        className: "properties-header",
        children: [/*#__PURE__*/_jsx("h3", {
          children: "Properties"
        }), onToggleCollapse && /*#__PURE__*/_jsx("button", {
          type: "button",
          onClick: onToggleCollapse,
          className: "properties-toggle-btn",
          title: "Collapse Properties",
          children: "\u25C0"
        })]
      }), /*#__PURE__*/_jsx("div", {
        className: "properties-content",
        children: /*#__PURE__*/_jsx("p", {
          children: "Select a field to edit its properties"
        })
      })]
    });
  }
  return /*#__PURE__*/_jsxs("div", {
    className: "builder-properties",
    children: [/*#__PURE__*/_jsxs("div", {
      className: "properties-header",
      children: [/*#__PURE__*/_jsx("h3", {
        children: "Properties"
      }), onToggleCollapse && /*#__PURE__*/_jsx("button", {
        type: "button",
        onClick: onToggleCollapse,
        className: "properties-toggle-btn",
        title: "Collapse Properties",
        children: "\u25C0"
      })]
    }), /*#__PURE__*/_jsxs("div", {
      className: "properties-content",
      children: [/*#__PURE__*/_jsx(BasicProperties, {
        field: selectedFieldData,
        updateField: updateField,
        selectedField: selectedField
      }), /*#__PURE__*/_jsx(DefaultValueProperty, {
        field: selectedFieldData,
        updateField: updateField,
        selectedField: selectedField
      }), /*#__PURE__*/_jsx(HiddenFieldProperty, {
        field: selectedFieldData,
        updateField: updateField,
        selectedField: selectedField
      }), /*#__PURE__*/_jsx(DefaultSelectionProperty, {
        field: selectedFieldData,
        updateField: updateField,
        selectedField: selectedField
      }), /*#__PURE__*/_jsx(SwitchDefaultProperty, {
        field: selectedFieldData,
        updateField: updateField,
        selectedField: selectedField
      }), /*#__PURE__*/_jsx(ColumnWidthProperty, {
        field: selectedFieldData,
        updateField: updateField,
        selectedField: selectedField
      }), /*#__PURE__*/_jsx(RequiredProperty, {
        field: selectedFieldData,
        updateField: updateField,
        selectedField: selectedField
      }), /*#__PURE__*/_jsx(ContainerFieldsProperty, {
        field: selectedFieldData,
        fields: fields,
        selectedField: selectedField,
        updateField: updateField
      }), /*#__PURE__*/_jsx(CurrencyProperty, {
        field: selectedFieldData,
        updateField: updateField,
        selectedField: selectedField
      }), /*#__PURE__*/_jsx(PriceProperty, {
        field: selectedFieldData,
        updateField: updateField,
        selectedField: selectedField
      }), /*#__PURE__*/_jsx(PhoneProperty, {
        field: selectedFieldData,
        updateField: updateField,
        selectedField: selectedField
      }), /*#__PURE__*/_jsx(OptionsProperty, {
        field: selectedFieldData,
        updateOption: updateOption,
        removeOption: removeOption,
        addOption: addOption
      }), /*#__PURE__*/_jsx(HeadingTagProperty, {
        field: selectedFieldData,
        updateField: updateField,
        selectedField: selectedField
      }), /*#__PURE__*/_jsx(ParagraphTypeProperty, {
        field: selectedFieldData,
        updateField: updateField,
        selectedField: selectedField
      }), /*#__PURE__*/_jsx(MultiselectProperty, {
        field: selectedFieldData,
        updateField: updateField,
        selectedField: selectedField
      }), /*#__PURE__*/_jsx(RepeaterFieldsProperty, {
        field: selectedFieldData,
        updateRepeaterField: updateRepeaterField,
        removeRepeaterField: removeRepeaterField,
        addRepeaterField: addRepeaterField
      }), /*#__PURE__*/_jsx(ValidationsProperty, {
        field: selectedFieldData,
        updateValidation: updateValidation,
        accordionStates: accordionStates,
        toggleAccordion: toggleAccordion
      }), /*#__PURE__*/_jsx(ConditionsProperty, {
        field: selectedFieldData,
        fields: fields,
        selectedField: selectedField,
        updateCondition: updateCondition,
        removeCondition: removeCondition,
        addCondition: addCondition,
        accordionStates: accordionStates,
        toggleAccordion: toggleAccordion
      })]
    })]
  });
};